import React from 'react';
import { styled } from '@mui/material';
import InsideLoading from 'components/loading/InsideLoading';
import NoData from 'components/no-data/NoData';
import { useFetchPatientRecord } from './hooks/useFetchPatientRecord';
import PatientRecordSummary from './PatientRecordSummary';
import RecordTimeline from 'components/record-ficha/RecordTimeline';

const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  minWidth: 0,
}));

interface PatientRecordContentProps {
  id: string | undefined;
  reloadKey?: number;
}

const PatientRecordContent: React.FC<PatientRecordContentProps> = ({ id, reloadKey }) => {
  const { record, loading, error } = useFetchPatientRecord(id, reloadKey);

  if (loading) return <InsideLoading />;

  if (error || !record) return <NoData message="Não foi possível carregar a ficha do paciente." />;

  return (
    <Content>
      <PatientRecordSummary record={record} />
      <RecordTimeline
        budgets={record.budgets.items}
        guides={record.guides.items}
        counterpart="doctor"
        subject="Este paciente"
      />
    </Content>
  );
};

export default PatientRecordContent;
